"use client";

import { useRef } from "react";
import { usePathname } from "next/navigation";
import { isExamInfoPage } from "@/lib/route-layout";
import { useEffectivePass } from "@/hooks/useEffectivePass";
import { ADSENSE_CLIENT, ADSENSE_SLOTS } from "@/lib/adsense";
import { useAdSensePush } from "@/hooks/useAdSensePush";
import { useIsDesktop } from "@/hooks/useViewport";

const DESKTOP_SLOT = ADSENSE_SLOTS.aboveLikeDesktop; // 728x90
const MOBILE_SLOT = ADSENSE_SLOTS.aboveLikeMobile; // 300x50

export default function AdSenseAboveLike() {
  const { isAdFree, isLoaded } = useEffectivePass();
  const pathname = usePathname();
  const showAds = isLoaded && !isAdFree && !isExamInfoPage(pathname);
  // 데스크톱/모바일 중 현재 뷰포트에 맞는 ins 하나만 렌더. 둘 다 CSS로 숨겨 두면
  // 잘못된 뷰포트의 hidden ins가 positional 큐를 오염시킨다(JCG-2057).
  const isDesktop = useIsDesktop();
  const insRef = useRef<HTMLModElement>(null);

  // resetKey=isDesktop: 뷰포트가 브레이크포인트를 넘어 ins 슬롯이 교체되면 다시 push
  useAdSensePush(insRef, showAds, isDesktop);

  if (!showAds) {
    return null;
  }

  return (
    <div className="my-4 flex justify-center">
      <ins
        // key: 뷰포트 교체 시 이전 ins(이미 초기화됨)를 재사용하지 않도록 새 노드로 마운트
        key={isDesktop ? "desktop" : "mobile"}
        ref={insRef}
        className="adsbygoogle"
        style={
          isDesktop
            ? { display: "inline-block", width: "728px", height: "90px" }
            : { display: "inline-block", width: "300px", height: "50px" }
        }
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={isDesktop ? DESKTOP_SLOT : MOBILE_SLOT}
      />
    </div>
  );
}
